import React from "react";
import PropTypes from "prop-types";
import s from "./Label.pcss";
import Icon from "../Icon/Icon";

const Label = (props) => (
    <button
        className={s.label}
        onClick={props.onRemove}
        id="remove-label"
        data-test-id="remove-label"
    >
        {props.text}
        <Icon name="line_close_icon" className={s.icon} width={8} height={8} />
    </button>
);

Label.propTypes = {
    text: PropTypes.string.isRequired,
    onRemove: PropTypes.func.isRequired,
};

export default Label;
